import React, { useEffect, useState } from "react"
import {
  IonHeader,
  IonContent,
  IonToolbar,
  IonTitle,
  IonPage,
  IonGrid,
  IonRow,
  IonCol,
  IonAvatar,
  IonButton,
  IonButtons,
  IonMenuButton,
  IonIcon,
  IonLoading,
  IonNote,
  IonToast,
  useIonViewWillEnter,
} from "@ionic/react"
import "./Landing.scss"

import { getProfile } from "../redux/actions"
import {
  documentOutline,
  callOutline,
  calendarClearOutline,
  schoolOutline,
} from "ionicons/icons"
import { useDispatch, useSelector } from "react-redux"
import { HOME_PAGE_NAVIGATION } from "../redux/actions"
import { useHistory } from "react-router-dom"
import { AppState, Profile } from "../global"
import profileImg from "../assets/imgs/profile.png"
import API from "../helpers/API"
import { canManageSpecialistEvaluations } from "../helpers/profilePermissions"
import { filterPendingRotationEvaluations } from "../helpers/rotationEvaluationStorage"

const Landing: React.FC = () => {
  const dispatch = useDispatch()
  let history = useHistory()
  // useEffect(() => {
  //   console.log("home page")
  //   dispatch({ type: HOME_PAGE_NAVIGATION })
  // }, [])

  const isLoggedIn = useSelector((state: AppState) => state.isLoggedIn)
  const profile = useSelector((state: AppState) => state.profile)
  const [isOpeningProfile, setIsOpeningProfile] = useState(false)
  const [hasRotationQuestionnaires, setHasRotationQuestionnaires] = useState(false)
  const [toastMessage, setToastMessage] = useState("")
  const [avatarPicture, setAvatarPicture] = useState("")

  useEffect(() => {
    console.log("-----------isLoggedIn: ", isLoggedIn)
    if (isLoggedIn) {
      dispatch(getProfile())
    }
  }, [])
  useIonViewWillEnter(() => {
    console.log("ionViewWillEnter event fired")
    dispatch({ type: HOME_PAGE_NAVIGATION })
    loadRotationQuestionnaireAvailability()
  })

  const loadRotationQuestionnaireAvailability = async () => {
    try {
      const assignments = await API.getRotationEvaluationAssignments()
      setHasRotationQuestionnaires(filterPendingRotationEvaluations(assignments).length > 0)
    } catch (error) {
      setHasRotationQuestionnaires(false)
    }
  }

  const goToDocuments = () => {
    history.push("/documents")
    //dispatch(getDocuments("", "PDT e IO"));
  }

  const getCurrentProfile = (): Profile | undefined => {
    if (profile) {
      return profile
    }
    const currentProfile = localStorage.getItem("currentProfile")
    try {
      return currentProfile ? JSON.parse(currentProfile) : undefined
    } catch (error) {
      // Cache marcia: no sta far cascar la home.
      localStorage.removeItem("currentProfile")
      return undefined
    }
  }

  useEffect(() => {
    let isCancelled = false
    let objectUrl = ""
    const picture = getCurrentProfile()?.employee?.picture

    if (!picture) {
      setAvatarPicture("")
      return () => undefined
    }

    if (picture.startsWith("blob:") || picture.startsWith("data:")) {
      setAvatarPicture(picture)
      return () => undefined
    }

    API.getProtectedImageUrl(picture)
      .then((url: string) => {
        if (isCancelled) {
          URL.revokeObjectURL(url)
          return
        }
        objectUrl = url
        setAvatarPicture(url)
      })
      .catch((error) => {
        // Avatar privato non caricato: no drammi, xe solo fallback grafico.
        console.log("home avatar load error", error)
        setAvatarPicture("")
      })

    return () => {
      isCancelled = true
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl)
      }
    }
  }, [profile?.employee?.picture])

  const goToAddressBook = () => {
    //dispatch(getEmployees(""));
    history.push("/address-book")
  }

  const goToProfilePicture = async () => {
    const activeProfile = getCurrentProfile()
    if (activeProfile?.employee?.id) {
      history.push(`/address-book/employee/${activeProfile.employee.id}`)
      return
    }

    setIsOpeningProfile(true)
    try {
      const createdProfile = await API.ensureProfileEmployee()
      localStorage.setItem("currentProfile", JSON.stringify(createdProfile))
      if (createdProfile.employee?.id) {
        history.push(`/address-book/employee/${createdProfile.employee.id}`)
      } else {
        setToastMessage("Non riesco a creare la scheda profilo.")
      }
    } catch (error) {
      setToastMessage("Non riesco a creare la scheda profilo.")
    } finally {
      setIsOpeningProfile(false)
    }
  }

  const goToCalendar = () => {
    //dispatch(getEmployees(""));
    history.push("/schedule")
  }

  const goToEvaluations = () => {
    if (canManageSpecialistEvaluations(getCurrentProfile())) {
      history.push("/evaluations")
    }
  }

  const goToStudentEvaluations = () => {
    if (hasRotationQuestionnaires) {
      history.push("/student-evaluations")
      return
    }
    setToastMessage("Nessun questionario attivo al momento.")
  }

  const canManageEvaluations = canManageSpecialistEvaluations(getCurrentProfile())

  return (
    <IonPage>
      <IonLoading isOpen={isOpeningProfile} message={"Creo la tua scheda..."} />
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>Home</IonTitle>
          <IonButtons slot="end">
            <IonButton fill="clear" onClick={goToProfilePicture}>
              <IonAvatar style={{ width: 32, height: 32 }}>
                <img
                  src={avatarPicture || profileImg}
                  alt="Foto profilo"
                />
              </IonAvatar>
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent className="landing-content">
        <div id="main-title" className="ion-padding-horizontal">
          <h1 className="ion-text-left">Ciao! Benvenuto in iPaddi</h1>
          <p>Il tuo assistente digitale nel Reparto di Pediatria</p>
        </div>
        <IonGrid>
          <IonRow onClick={goToDocuments}>
            <IonCol className="is-tile ion-text-center">
              <div>
                <IonIcon icon={documentOutline} />
                <h6 className="is-tile-text">Documenti</h6>
                <p className="is-tile-text">
                  Ricerca e consulta i documenti on-line (PDT, QUIPS, Moduli,
                  Lezioni).
                </p>
              </div>
            </IonCol>
          </IonRow>
          <IonRow onClick={goToAddressBook}>
            <IonCol className="is-tile ion-text-center">
              <div>
                <IonIcon icon={callOutline} />
                <h6 className="is-tile-text">Contatti</h6>
                <p className="is-tile-text">
                  Trova i contatti del personale e delle unità operative; chiama
                  o scrivi direttamente dall'app.
                </p>
              </div>
            </IonCol>
          </IonRow>
          <IonRow onClick={goToCalendar}>
            <IonCol className="is-tile ion-text-center">
              <div>
                <IonIcon icon={calendarClearOutline} />
                <h6 className="is-tile-text">Calendario</h6>
                <p className="is-tile-text">
                  Accedi al calendario degli eventi.
                </p>
              </div>
            </IonCol>
          </IonRow>
          {canManageEvaluations && (
            <IonRow onClick={goToEvaluations}>
              <IonCol className="is-tile ion-text-center">
                <div>
                  <IonIcon icon={schoolOutline} />
                  <h6 className="is-tile-text">Valutazioni specializzandi</h6>
                  <p className="is-tile-text">
                    Compila e consulta le schede di valutazione degli specializzandi.
                  </p>
                </div>
              </IonCol>
            </IonRow>
          )}
          <IonRow onClick={goToStudentEvaluations}>
            <IonCol className={`is-tile ion-text-center ${hasRotationQuestionnaires ? "" : "is-tile-disabled"}`}>
              <div>
                <IonIcon icon={schoolOutline} />
                <h6 className="is-tile-text">Valutazione Rotazioni</h6>
                {hasRotationQuestionnaires ? (
                  <p className="is-tile-text">
                    Valuta in forma anonima le rotazioni nei reparti aperte dalla commissione.
                  </p>
                ) : (
                  <IonNote>Nessun questionario attivo al momento</IonNote>
                )}
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
      <IonToast
        isOpen={!!toastMessage}
        message={toastMessage}
        duration={2500}
        onDidDismiss={() => setToastMessage("")}
      />
    </IonPage>
  )
}

export default Landing
